import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import '@resources/scss/vue/libs/toastification.scss';  // Ensure the path is correct

const options = {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
};

export default function setupToast(app) {
  app.use(Toast, options);
}
